import cookie from 'cookie';
import { IncomingMessage } from 'http';
import * as jose from 'jose';

const ACCESS_TOKEN_KEY = 'access_token';

export const setCookie = (key: string, value: string) => {
  document.cookie = cookie.serialize(key, value, {
    maxAge: 30 * 24 * 60 * 60, // 30 days
    path: '/'
  });
};

export const removeCookie = (key: string) => {
  document.cookie = cookie.serialize(key, '', {
    maxAge: -1, // Expire the cookie immediately
    path: '/'
  });
};

export function getToken(req?: IncomingMessage | undefined) {
  let str = '';
  if (req?.headers.cookie) {
    str = req.headers.cookie;
  } else if (typeof document !== 'undefined' && document.cookie) {
    str = document.cookie;
  }
  return cookie.parse(str)[ACCESS_TOKEN_KEY];
}

export function setTokenCookie(token: string) {
  setCookie(ACCESS_TOKEN_KEY, token);
}

export function removeTokenCookie() {
  removeCookie(ACCESS_TOKEN_KEY);
}

// The back end only keeps a relative originUrl: it has to be encoded to carry its own query string
export const getSamlLoginUrl = (pathname: string, search = ''): string => {
  const params = new URLSearchParams(search);
  // An expired token left in the URL would be read again after the login, before the new one
  params.delete('credentials');
  const query = params.toString();
  const originUrl = query ? `${pathname}?${query}` : pathname;

  return `${
    process.env.REACT_APP_API_URL
  }/v1/auth/saml/login?originUrl=${encodeURIComponent(originUrl)}`;
};

export const getDecodedJWT = (jwt: string | null) => {
  let decodedJwt = null;

  if (jwt) {
    try {
      decodedJwt = jose.decodeJwt(jwt);
    } catch (e) {
      console.error(e);
    }
  }
  return decodedJwt;
};
